var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cartItemValidationResult.exceedStock
    ? _c(
        "div",
        { staticClass: "small message-indicator" },
        [
          _vm.cartItemValidationResult.stockAvailable <= 0
            ? [
                _c(
                  "p",
                  { staticClass: "mb-0 text-end text-danger font-weight-bold" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ATM.CART.PRODUCT_WITHOUT_STOCK")) +
                        " "
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "p",
                  {
                    staticClass:
                      "mb-0 text-end text-danger font-weight-bold text-end",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$tc(
                            "ATM.CART.AVAILABLE_STOCK",
                            _vm.cartItemValidationResult.stockAvailable,
                            {
                              quantity:
                                _vm.cartItemValidationResult.stockAvailable,
                            }
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("p", { staticClass: "mb-0 text-end" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$tc(
                          "ATM.CART.QUANTITY_IN_CART",
                          _vm.cartItemValidationResult.cartQuantity,
                          {
                            quantity: _vm.cartItemValidationResult.cartQuantity,
                          }
                        )
                      ) +
                      " "
                  ),
                ]),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }